import * as React from "react";
import MovieList from "../containers/MovieList";
import Shell from "./Shell";

const Home = ({ location, history }) => {
    return <Shell>
        {({ mutations, queries }) =>
            <MovieList
                locationPath=""
                user={queries.getUser && queries.getUser.data.user}
                userProfile={queries.getUserProfile.data && queries.getUserProfile.data.userProfile}
                movieListId={"raL4G3ZMQFOa5nzYx7bG"} />}
    </Shell>;
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home.tsx